import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function PsflineReducer(state = initialState.psfline, action: any) {
  switch (action.type) {
    case types.SAVE_PSFLINE_SUCCESS:
      return action.psfline;
    default:
      return state;
  }
}
